<template>
	<modal :show.sync=show :hide-footer=true modalClasses="add-remarks">
	<h3 slot="header" class="mb-0 font-weight-500">
		Add Remark
		<b-icon icon="dollar" class="mr-3" variant="gray"></b-icon>
	</h3>
		<b-form ref="customerForm" role="form" @submit.prevent="submit()" class="mt--4">
			<b-row>
				<b-col cols="12">
					<b-form-textarea v-model="remark" rows="8" required></b-form-textarea>
				</b-col>
				<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2" slot="footer">
					<b-button type="submit" class="w-100" variant="primary">Submit</b-button>
				</b-col>
			</b-row>
		</b-form>
	</modal>
</template>

<script>

import Modal from "@/components/Modal";
import { Switch } from 'element-ui'
import { services } from '@/assets/js/config.js';

export default {
	props: {
		show_remark_modal: Boolean
	},
	components: {
		Modal,
		[Switch.name]: Switch,
	},
	data() {
		return {
			remark: null,
			show: false,
		}
	},
	methods: {
		viewAddRemark() {
			this.show = !this.show
		},
		submit() {
			let form = new FormData()
			form.append('remark', this.remark ?? '')
			axios.post(services.lead + 'lead/' + this.$route.params.lead_id + '/remarks', form, { headers: getHeader() })
			.then(res => {
				this.remark = null;
				_gNotif.notifySuccess('<b>Lead Remark : </b> - Successfully Created.')
				this.$emit('add-remark', res.data.data);
				this.$emit('update:show_remark_modal', false);
			})
			.catch(e => {
				_gNotif.errorFunction(e)
			})
		},
	}
}
</script>